export default __webpack_public_path__ + "static/media/icon_circle_close.cf2a3d5c.svg";